import ContentBlock from './ContentBlock';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { navigate } from 'state/Routing/actions';

export default compose<typeof ContentBlock>(connect(null, { navigate }))(
  ContentBlock,
);
